import NextLink from 'next/link';
import { Icons } from '../../atoms/icons';
import { IBtnBackInterface } from './btnBack.interface';
import styles from './btnBack.module.scss';

export const BtnBack = (props: IBtnBackInterface) => {
	const { text, href } = props;

	return (
		<div className={styles['btn-back']}>
			<NextLink href={ href } passHref>
				<a>
					<Icons iconName='iconChevronLeft' />
					<p>
						{ text }
					</p>
				</a>
			</NextLink>
		</div>
	)
}